﻿import type {
    CustomPlatformAssemblyConfig,
    CustomPlatformPropPlacementConfig,
    IndividualContentPlatformPlacementConfig,
} from './IndividualPlatformTypes'

export const level2CustomPlatformAssemblies: readonly CustomPlatformAssemblyConfig[] = []

export const level2CustomPlatformPropPlacements: readonly CustomPlatformPropPlacementConfig[] = [
    {
        name: 'Level2Clock01',
        platformRegion: 2,
        propAsset: 'LVL2_Clock',
        propPosition: [-4, 9, -500],
        propRotation: [0.0, 0.4, 0.0],
        propScale: 2,
        platformScale: 3,
    },
    {
        name: 'Level2Clock02',
        platformRegion: 2,
        propAsset: 'LVL2_Clock',
        propPosition: [8, -5, -725],
        propRotation: [-0.04, 0.95, 0.06],
        propScale: 2,
        platformScale: 4,
    },
       {
        name: 'Level2Clock03',
        platformRegion: 2,
        propAsset: 'LVL2_Clock',
        propPosition: [78, 4, -785],
        propRotation: [-0.04, -0.95, 0.06],
        propScale: 1.5,
        platformScale: 4,
    },
    {
        name: 'Level2Geometries01',
        platformRegion: 2,
        propAsset: 'LVL2_Geometries',
        propPosition: [56, 4, -535],
        propRotation: [0, -0.8, 0],
        propScale: 3.5,
        platformScale: 0,
    },
    {
        name: 'Level2Geometries02',
        platformRegion: 2,
        propAsset: 'LVL2_Geometries',
        propPosition: [58, 0, -890],
        propRotation: [0.08, -0.65, 0.05],
        propScale: 4.9,
        platformScale: 0,
    },
    {
        name: 'Level2Globe01',
        platformRegion: 2,
        propAsset: 'LVL2_Globe',
        propPosition: [76, 8, -610],
        propRotation: [0, -1, 0],
        propScale: 3,
        platformScale: 3,
    },
    {
        name: 'Level2Globe02',
        platformRegion: 2,
        propAsset: 'LVL2_Globe',
        propPosition: [-28, -70, -910],
        propRotation: [-0.0, -0.4, 0.4],
        propScale: 8,
        platformScale: 0,
    },
        {
        name: 'Level2Globe03',
        platformRegion: 2,
        propAsset: 'LVL2_Globe',
        propPosition: [-18, -70, -1180],
        propRotation: [-0.0, -2.9, 0],
        propScale: 12,
        platformScale: 0,
    },
    {
        name: 'Level2MathScience01',
        platformRegion: 2,
        propAsset: 'LVL2_MathScience',
        propPosition: [38, -2, -750],
        propRotation: [0, 0.2, 0.2],
        propScale: 6,
        platformScale: 0,
    },
    {
        name: 'Level2MathScience02',
        platformRegion: 2,
        propAsset: 'LVL2_MathScience',
        propPosition: [-60, 2, -1080],
        propRotation: [1, -0.0, -0.03],
        propScale: 4.7,
        platformScale: 0,
    },
] as const

export const level2IndividualContentPlatformPlacements: readonly IndividualContentPlatformPlacementConfig[] = []
